import React from 'react'

import Modal from 'components/Modal'
import CustomerContactForm from './CustomerContactForm'
import Header from './Header'

class Unauthorized extends React.Component {
  state = {
    showModal: false,
  }

  render() {
    return (
      <React.Fragment>
        <Header
          noBurger
          menu={[
            {
              link: '/login',
              text: 'Logg inn',
            },
            {
              onClick: () => this.setState({ showModal: true }),
              text: 'Oppdragsgiver'
            },
          ]}
        />
        <Modal
          title="Trenger du noen til å gjøre en jobb for deg?"
          small
          isOpen={this.state.showModal}
          onRequestClose={() => this.setState({ showModal: false })}>
          <CustomerContactForm
            closeModal={() => this.setState({ showModal: false })}
          />
        </Modal>
      </React.Fragment>
    )
  }
}

export default Unauthorized



// WEBPACK FOOTER //
// ./src/components/Header/Unauthorized.js